import { render, staticRenderFns } from "./DementiaKnowledgeGeneral.vue?vue&type=template&id=956677d0&lang=true&"
import script from "./DementiaKnowledgeGeneral.vue?vue&type=script&lang=js&"
export * from "./DementiaKnowledgeGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
